import { Common } from '~/models/common';

export namespace Feedback {
	export const collection = 'feedback';
	export const api = `/api/${collection}`;

	export type Model = Common.Model & {
		source: string | null;
		name: string | null;
		phone: string | null;
		email: string | null;
		subject: string | null;
		target: string | null;
	};

	export const modelState: Model = {
		...Common.modelState,
		source: null,
		name: null,
		phone: null,
		email: null,
		subject: null,
		target: null,
	};
}
